import { DeviceInfo, GpsHistoryLocation, Log, LogParserMetadata, OrderInLog } from '@/parsing/Log';

import { deserializeLogEntry, SerializedLogEntry, serializeLogEntry } from './SerializedLogEntry';

export interface SerializedLog {
  uniqueId: string;
  parserMetadata: LogParserMetadata;
  entries: SerializedLogEntry[];
  modules: string[];

  foundUserIDs: string[];
  foundOrders: OrderInLog[];
  deviceInfo: DeviceInfo;

  gpsHistory: {
    locations: GpsHistoryLocation[];
  };

  fileBoundaries?: { fileName: string; firstEntryIndex: number }[];
  skippedFiles?: string[];
}

export function serializeLog(log: Log): SerializedLog {
  return {
    uniqueId: log.uniqueId,
    parserMetadata: log.parserMetadata,
    entries: log.entries.map((e) => serializeLogEntry(e)),
    modules: log.modules,
    foundUserIDs: log.foundUserIDs,
    foundOrders: log.foundOrders,
    deviceInfo: log.deviceInfo,
    gpsHistory: log.gpsHistory,
    fileBoundaries: log.fileBoundaries,
    skippedFiles: log.skippedFiles,
  };
}

export function deserializeLog(slog: SerializedLog): Log {
  return {
    uniqueId: slog.uniqueId,
    parserMetadata: slog.parserMetadata,
    entries: slog.entries.map((e) => deserializeLogEntry(e)),
    modules: slog.modules,
    foundUserIDs: slog.foundUserIDs,
    foundOrders: slog.foundOrders,
    deviceInfo: slog.deviceInfo || {},
    gpsHistory: slog.gpsHistory,
    fileBoundaries: slog.fileBoundaries ?? [],
    skippedFiles: slog.skippedFiles ?? [],
  };
}
